<template>
	<SuiAvatar
		:url="url"
		:show-border="true"
		size="x-small"
		:initials="initials"
		:color="color"
	/>
</template>
<script setup lang="ts">
import { SuiAvatar } from '@developers/scoro-ui';
import { type User } from '@/generated/graphql';

export type ResourcePlanningAvatarProps = {
	url: string;
	initials: NonNullable<User['initials']>;
	color: NonNullable<User['hslColor']>;
};

defineProps<ResourcePlanningAvatarProps>();
</script>
